import { KibsiClient } from './base';
const SERVICE = 'tenant';
export class SiteKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    list(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { siteIds, includeCounts } = criteria ?? {};
        return this.get('/sites', {
            ...requestConfig,
            ...{ params: { continuationToken, pageSize, sort, siteIds: siteIds?.join(','), includeCounts } },
        });
    }
    read(entityId, requestConfig) {
        return this.get(`/sites/${entityId}`, requestConfig);
    }
    create(entity, requestConfig) {
        return this.post('/sites', entity, requestConfig);
    }
    update(entity, requestConfig) {
        return this.put(`/sites/${entity.siteId}`, entity, requestConfig);
    }
    delete(siteId, requestConfig) {
        return this.del(`/sites/${siteId}`, requestConfig);
    }
}
//# sourceMappingURL=site.js.map